import React from 'react';
import { getNetwork } from '@dcl/schemas/dist/dapps/chain-id';
import { ToastType } from 'decentraland-ui';
import { getNetworkName } from 'decentraland-ui/dist/lib/network';
import { t } from '../../translation/utils';
export function getSwitchChainErrorToast(chainId) {
    return {
        type: ToastType.ERROR,
        title: t('@dapps.toasts.switch_network_error.title'),
        body: (React.createElement("div", null, t('@dapps.toasts.switch_network_error.body', {
            network: getNetworkName(getNetwork(chainId))
        }))),
        closable: true,
        timeout: 30000
    };
}
//# sourceMappingURL=index.js.map